
import backend from '../apis/backend';
import stravaGet from '../apis/stravaGet';
import {saveActivities} from '../helperFunctions/stravaImport'

export const logIn = (loginForm) => {
    return async (dispatch) => {
        const response =  await backend.get('/login_react',{
            auth: {
                username: loginForm.email,
                password: loginForm.password 
              }
        })
        .then(response =>{
            if (response.status === 200) {
                localStorage.setItem("retry",0)
                dispatch({
                    type: 'LOG_IN', 
                    payload: response.data
                })
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                return response;
            
              }
              else if (response.status === 500){
                  console.log('server test')
              }
               else {
                if (response.message){
                    console.log(response,"heeeeeeyyyy")
                }
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                throw new Error('Something went wrong on api server!');
              }
        })
        
    }
}

export const register = (user) => {
    //const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.post('/register_react',{
            email:user.email,
            username:user.username,
            password:user.password,
            age:user.age,
            male:user.male,
            measurementSystem:user.measurementSystem,
        },
        {  
            headers: {
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}


export const fetchUser = () => {
    
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        dispatch({
            type: "LOADING_START",
        })
        const response =  await backend.get('/user',{
            headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
        }})
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "LOADING_END",
                })
                dispatch({
                    type: "LOADING_END",
                })
                dispatch({
                    type: 'LOG_IN', 
                    payload: response.data
                })
                
                return response;
              } else {
                if (response.message){
                    console.log(response,"heeeeeeyyyy")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            localStorage.setItem("retry",parseInt(localStorage.getItem("retry"))+1)
                    if (parseInt(localStorage.getItem("retry"))<3){
                  
                        setTimeout(function (){dispatch(
                            fetchUser()
                        )}, 2000)  
                    }
                    else{
                        dispatch({ 
                            type: "CREATE_MESSAGE", 
                            message: {'message':["logout",JSON.stringify(error.message)]} 
                        })
                        //alert(localStorage.getItem("retry"))
                        localStorage.clear()
                        window.location.replace("/login")
                    }
        })
        
    }
}

export const fetchPosts = () => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.get('/get_user_posts',{
            headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
        }})
        .then(response =>{
            if (response.status === 200) {
                localStorage.setItem("retry",0)
                dispatch({
                    type: 'FETCH_ACTIVITIES', 
                    payload: response.data
                })
                dispatch({
                    type: "LOADING_END",
                })
                return response;
              } else {
                if (response.status>400){
                    localStorage.setItem("retry",parseInt(localStorage.getItem("retry"))+1)
                    if (parseInt(localStorage.getItem("retry"))<3){
                  
                        setTimeout(function (){dispatch(
                            fetchPosts()
                        )}, 2000)  
                    }
                    else{
                        dispatch({ 
                            type: "CREATE_MESSAGE", 
                            message: {'message':["logout","Log in again"]} 
                        })
                    }
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            localStorage.setItem("retry",parseInt(localStorage.getItem("retry"))+1)
                    if (parseInt(localStorage.getItem("retry"))<3){
                  
                        setTimeout(function (){dispatch(
                            fetchPosts()
                        )}, 2000)  
                    }
                    else{
                        dispatch({ 
                            type: "CREATE_MESSAGE", 
                            message: {'message':["logout",JSON.stringify(error.message)]} 
                        })
                        //alert(localStorage.getItem("retry"))
                        localStorage.clear()
                        window.location.replace("/login")
                    }
        })
    }
}

export const fetchFuturePosts = () => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.get('/get_user_future_posts',{
            headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
        }})
        .then(response =>{
            if (response.status === 200) {
                localStorage.setItem("retry",0)
                dispatch({
                    type: 'FETCH_FUTURE_ACTIVITIES', 
                    payload: response.data
                })
                return response;
              } else {
                if (response.status>400){
                    localStorage.setItem("retry",parseInt(localStorage.getItem("retry"))+1)
                    if (parseInt(localStorage.getItem("retry"))<3){
                  
                        setTimeout(function (){dispatch(
                            fetchFuturePosts()
                        )}, 2000)  
                    }
                    else{
                        dispatch({ 
                            type: "CREATE_MESSAGE", 
                            message: {'message':["logout","Log in again"]} 
                        })
                    }
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            localStorage.setItem("retry",parseInt(localStorage.getItem("retry"))+1)
                    if (parseInt(localStorage.getItem("retry"))<3){
                  
                        setTimeout(function (){dispatch(
                            fetchPosts()
                        )}, 2000)  
                    }
                    else{
                        dispatch({ 
                            type: "CREATE_MESSAGE", 
                            message: {'message':["logout",JSON.stringify(error.message)]} 
                        })
                    }
        })
    }
}

export const fetchRunningProgram = () => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.get('/showprogram',{
            headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
        }})
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: 'FETCH_RUNNING_PROGRAM', 
                    payload: response.data
                })
                return response;
              } else {
                if (response.status>400){
                    console.log(response,"heeeeeeyyyy")
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}


export const deleteEntry = (id) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.delete('/deleteentry',{
            headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
        },
        data: {
            id : id
        }

        })
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch({
                    type: 'DELETE_ITEM',
                    payload: id
                })

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}


export const deleteWeekPlan = (id) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.delete('/delete_week_plan',{
            headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
        },
        data: {
            id : id
        }

        })
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch({
                    type: 'DELETE_WEEK',
                    payload: id
                })

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}
export const countsDontCounts = (id) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.put('/countsforfitnessreact',{
            id:id,
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        })
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchPosts()
                )

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}
export const initializeProgramInDatabase = (programData) => {
    const token = localStorage.getItem("token")
    //alert(token)
    return async (dispatch) => {
        const response =  await backend.put('/generateprogram',{
            tss_target:programData.tss_target,
            targetForm:programData.targetForm,
            planType:programData.planType,
            runningProgram:programData.runningProgram,
            program_runs_per_week:programData.program_runs_per_week,
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchRunningProgram()
                )
                //dispatch({
                //    type: 'DELETE_ITEM',
                //    payload: id
                //})

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}


/*
user.rest_hr = data["rest_hr"]
    user.max_hr = data['max_hr']
    user.lactate_th =data['lactate']
    user.username = data['username']
    user.measurement_system = data['measurementSystem']
    if data['sex']=='Female':
        user.male = False
    else:
        user.male = True
    
    user.age = data['age']

*/
export const editUserData = (userData) => {
    const token = localStorage.getItem("token")
    //alert(token)
    return async (dispatch) => {
        const response =  await backend.put('/edit_account',{
            rest_hr:userData.rest_hr,
            max_hr:userData.max_hr,
            lactate_th:userData.lactate_th,
            lactate_cycle:userData.lactate_cycle,
            lactate_swim:userData.lactate_swim,
            username:userData.username,
            measurementSystem:userData.measurementSystem,
            male:userData.male,
            age:userData.age
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchUser()
                )
                //dispatch({
                //    type: 'DELETE_ITEM',
                //    payload: id
                //})

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}

export const changePassword = (password) => {
    const token = localStorage.getItem("token")
    //alert(token)
    return async (dispatch) => {
        const response =  await backend.put('/edit_account',{
            password:password,
            
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchUser()
                )
                //dispatch({
                //    type: 'DELETE_ITEM',
                //    payload: id
                //})

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}
export const editActivityData = (data) => {
    const token = localStorage.getItem("token")
    //alert(token)
    return async (dispatch) => {
        const response =  await backend.put('/edit_activity',{
            id:data.id,
            type:data.type,
            subType:data.subType,
            duration:data.duration,
            distance:data.distance,
            heartRate:data.heartRate,
            tss:data.tss,
            trimp:data.trimp,
            name:data.name
            
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchPosts()
                )
                //dispatch({
                //    type: 'DELETE_ITEM',
                //    payload: id
                //})

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}
export const stravaAuthFetch = (authCode) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.post('/strava_auth',{
            authCode:authCode
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchUser()
                )

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}

export const stravaRefreshTokenToAccessToken = (refreshToken,i) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.post('/strava_refresh_token',{
            refreshToken:refreshToken
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from stravaRefreshTokenToAccessToken")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    stravaGetActivities(response.data.access_token,i)
                )

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}


export const stravaGetActivities = (accessToken,i=1) => {
    
    console.log("access_token",accessToken)
    return async (dispatch) => {
        dispatch({
            type: "LOADING_START",
        })
        const response =  await stravaGet.get(`/activities?page=${i}&per_page=200`,{
            headers: { Authorization: `Bearer ${accessToken}` }
        })
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from strava")
                const activities = saveActivities(response.data)
                //console.log(activities)
                dispatch(
                    strava_import(activities)
                )
                
                return response;
              } else {
                if (response.message){
                    console.log(response,"heeeeeeyyyy")
                }
               
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            dispatch({
                type: "LOADING_END",
            })
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
        
    }
}



export const strava_import = (activities) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.post('/strava_import_react',{
            activities
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from stravaRefreshTokenToAccessToken")
                dispatch({
                    type: "LOADING_END",
                })
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchPosts()
                )

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}


export const stravaUnpair = () => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.delete('/strava_unpair',{
            headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
        },

        })
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchUser()
                )

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}


export const createSingleEntry = (activity) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.post('/create_single_entry',{
            date:activity.date,
            time:activity.duration,
            distance:activity.distance,
            hr:activity.heartRate,
            up:activity.up,
            down:activity.down,
            runningIndex:activity.runningIndex,
            tss:activity.tss,
            trimp:activity.trimp
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from createentry")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchPosts()
                )

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}

export const getTokenForReset = (email) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.post('/password_reset',{
            email:email,
        },
        {  
            headers: {
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from createentry")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}


export const resetPasswordCall = (data) => {
    const token = localStorage.getItem("token")
    //alert(token)
    return async (dispatch) => {
        const response =  await backend.put('/edit_account',{
            password:data.password,
            
        },
        {  
            headers: {
                "x-access-token":data.token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from login")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchUser()
                )
                //dispatch({
                //    type: 'DELETE_ITEM',
                //    payload: id
                //})

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}


export const createWeekPlanDatabase = (plan,date) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.post('/create_plan',{
            plan:plan,
            date:date,
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from stravaRefreshTokenToAccessToken")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchFuturePosts()
                )

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}

export const editWeekPlanDatabase = (plan,date,id) => {
    const token = localStorage.getItem("token")
    return async (dispatch) => {
        const response =  await backend.put('/edit_plan',{
            plan:plan,
            date:date,
            id:id,
        },
        {  
            headers: {
                "x-access-token":token,
                "Content-Type": "application/json"
            }
        }
        )
        .then(response =>{
            if (response.status === 200) {
                console.log(response.data,"response from stravaRefreshTokenToAccessToken")
                dispatch({
                    type: "CREATE_MESSAGE",
                    message: response.data
                })
                dispatch(
                    fetchFuturePosts()
                )

                return response;
              } else {
                if (response.status>400){
                    dispatch({
                        type: "CREATE_MESSAGE",
                        message: response
                    })
                    localStorage.clear()
                    window.location.replace("/login")
                }
                throw new Error('Something went wrong on api server!');
              }
        })
        .catch(error => {
            
            dispatch({ 
                type: "CREATE_MESSAGE", 
                message: {'message':["danger",JSON.stringify(error.message)]} 
            })
        })
    }
}
//resetPasswordCall
//export const deleteEntry = (id) =>({
  //  type: 'DELETE_ITEM',
 //   payload: id
 //   
//})